import PasswordRequest from "theme/pages/PasswordManagment/PasswordRequest";

export default PasswordRequest;
